// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"245":"69771503","615":"f24e6dde","787":"c930fbae"}[chunkId] + ".chunk.js";
};